<template>
  <responsive-modal v-model="visible">
    <div class="product-facebook-pixel-modal p-5">
      <button class="btn text-secondary close" @click="visible = false">
        <i class="icon-x" />
      </button>
      <div class="mb-5">
        <strong>
          API de Conversões do Facebook
        </strong>
      </div>
      <small>
        <div class="mb-5">
          <a
            target="_blank"
            href="https://www.facebook.com/business/help/2041148702652965?id=818859032317965"
            class="text-primary font-weight-bold text-decoration-none"
          >
            Conheça a API de Conversões do Facebook
          </a>
        </div>
      </small>
      <hr />

      <form-group
        id="form-domain"
        v-model="form.domain"
        :errors="errors.domain"
        label="Domínio do site"
        placeholder="Digite a URL"
      />
      <form-group
        id="form-api_key"
        v-model="form.api_key"
        :errors="errors.api_key"
        label="Chave da API"
        placeholder="Digite o token"
      />
      <form-group
        id="form-ads_pixel_id"
        v-model="form.ads_pixel_id"
        :errors="errors.ads_pixel_id"
        label="ID do pixel"
        placeholder="Digite o pixel id do anúncio"
      />

      <div class="d-flex justify-content-center mt-5">
        <button
          class="btn btn-primary"
          :disabled="!isValid"
          :class="{
            'btn-secondary border-secondary': !isValid
          }"
          @click="submit"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>

<script>
import { clearObject, formFields } from "@/functions/helpers";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(["product_id", "domain", "api_key", "ads_pixel_id"]),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
      }
    }
  },
  computed: {
    ...mapState("product", ["product"]),
    isValid() {
      return this.form.domain && this.form.api_key && this.form.ads_pixel_id;
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    onSuccess() {
      this.loading = false;
      this.$message.success("A integração foi salva!");
      this.$emit("update-list");
      this.clear();
      this.visible = false;
    },
    submit() {
      this.loading = true;

      let data = {
        ...this.form,
        product_id: this.product.id
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, clearObject(data))
        .then(this.onSuccess)
        .catch(error => {
          this.errors = error.response.data;
          let errorMsg = get(error, "response.data.message");
          this.$message.error(errorMsg ? errorMsg : "Erro ao salvar");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.product-facebook-pixel-modal {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  button {
    i {
      font-size: 28px;
    }
  }
}
</style>
